export const REGISTRATION_STEPS = {
  EMAIL: 'email',
  CONFIRMATION_CODE: 'confirmation-code',
  PIN: 'pin',
  CONFIRMATION_PIN: 'confirmation-pin'
} as const
